import * as Html from "../util/Html.ts";
import * as blackveil from "../lib/blackveil2.ts";

export {initDom}
Html.registerWidget('widget/dropdown',{initDom})

Html.registerDom({
  opendropdown(){
    const item = this;
    const ancestorSelector = item.getAttribute('data-fw-dropdown-root');
    const commentedSelector = item.getAttribute('data-fw-dropdown-commented');
    const root = item.closest(ancestorSelector) as HTMLElement || item;
    const blackveilRootSelector = item.getAttribute('data-fw-blackveil-root');
    const blackveilRoot = blackveilRootSelector ? (blackveilRootSelector === '.' ? item : item.closest(blackveilRootSelector) as HTMLElement) : root;
    const commented = commentedSelector==='*'?root:root.querySelector(commentedSelector) as HTMLElement;
    const zIndex = parseInt(item.dataset.dropdownZindex) || 9;
    let closing = false;
    let close: (evt?) => void;
    let open: () => void;

    close = function(evt?) {
      closing = true;
      setTimeout(function() { closing = false; });
      blackveil.hide(blackveilRoot);
      root.classList.remove('fw-open');
      root.classList.remove('fw-open-upper');
      root.classList.remove('fw-open-middle');
      root.removeEventListener('click', close);
      document.removeEventListener('click', close);
    };
    open = function() {
      blackveil.show(blackveilRoot, zIndex).addEventListener('click', close);
      Html.enableComments(commented);
      commented.style.display = '';

      root.classList.add('fw-open');
      const rect = item.getClientRects()[0];
      const rectBody = document.body.getClientRects()[0];

      if (rect) {
        const delta = rectBody.height - rect.bottom;
        if (Math.abs(delta - rect.top) < 100) {
          root.classList.add('fw-open-middle');
        } else if (delta < rect.top) {
          root.classList.add('fw-open-upper');
        }
      }
    };

    // Note: swipe functionality would need to be implemented separately
    // or use a modern touch event library if needed

    if (closing) {
      // do nothing
    } else if (root.classList.contains('fw-open')) {
      close();
    } else {
      open();
    }
    return true;
  }
});

function initDom(o: HTMLElement) {
  if (!o.getAttribute('data-fw-onclick')) {
    o.setAttribute('data-fw-onclick', 'opendropdown');
  }
}
